import { Component, input, output } from '@angular/core';
import * as fromSeriousSystem from '@serious-system';

@Component({
  selector: 'squadbox-top-bar-mobile',
  imports: [
    fromSeriousSystem.IconButtonDirective,
    fromSeriousSystem.UseArrowIconDirective,
    fromSeriousSystem.UseUIBasicIconDirective,
  ],
  template: `
    <div
      class="
        flex gap-2 items-center
        p-2 z-10 w-full
        border-b border-neutral-200
        bg-shades-white
      "
    >
      <button
        sdIconButton
        variant="icon"
        color="neutral"
        size="md"
        (click)="chevronLeftButtonClicked.emit()"
      >
        <svg sdUseArrowIcon="chevron-left"></svg>
      </button>

      <div class="flex-1 typo-p2 text-nowrap truncate">
        <ng-content class="w-full block" />
      </div>
      @if (!hideMoreOptionsButton()) {
        <button
          sdIconButton
          variant="icon"
          color="neutral"
          size="md"
          data-chat-more-options-trigger
          (click)="moreOptionsClicked.emit()"
        >
          <svg sdUseUIBasicIcon="more-horizontal"></svg>
        </button>
      }
    </div>
  `,
  styles: [
    `
      @reference '../../../styles.css';

      :host {
        @apply block;
      }
    `,
  ],
})
export class TopBarMobileResponsive {
  public readonly hideMoreOptionsButton = input<boolean>(true);

  public readonly chevronLeftButtonClicked = output<void>();
  public readonly moreOptionsClicked = output<void>();
}
